// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import ServiceGallery from "./pages/ServiceGallery";
import Home from "./pages/Home"; // In case Shop is still used
import ServiceDetail from "./components/Service/ServiceDetail";
import Layout from "./Layout.js/Layout";
import NotFoundPage from "./pages/Notfound";
import About from "./pages/AboutUs";
import ContactUs from "./pages/Contactus";
import ScrollToTop from "./components/ScrollTop";
import ProductList from "./components/ProductList";
import Services from "./pages/Services";
import BackToTop from "./components/Backtotop";

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* <Route path="/" element={<ServiceGallery />} /> */}
        <Route path="/service/:serviceId" element={<Layout>
          <ServiceDetail />
        </Layout>} />
        <Route path="/service" element={<Layout>
          <Services />
        </Layout>} />
        <Route path="/about" element={<Layout>
          <About />
        </Layout>} />
        <Route path="/contact" element={<Layout>
          <ContactUs />
        </Layout>} />
        <Route path="/" element={<Home />} />
        <Route path="*" element={<Layout>
          <NotFoundPage />
        </Layout>} />

        <Route path="/products" element={<Layout><ProductList /></Layout>} />
        <Route path="/products/:category" element={<Layout><ProductList /></Layout>} />
      </Routes>
      {/* </ScrollToTop> */}
      <BackToTop />

    </Router>
  );
}
